<div class="bg">
  <div class="back1">
    <img
      src="{{ onPassiveBaseUrl }}onpassive-nov(1)/assets/images/back1.png"
      width="60%"
      alt="back1"
    />
  </div>
  <div class="human-robort">
    <div class="human-hand">
      <img
        src="{{ onPassiveBaseUrl }}onpassive-nov(1)/assets/images/hand.png"
        width="100%"
        alt="hand"
      />
    </div>
    <div class="robot-hand">
      <img
        src="{{ onPassiveBaseUrl }}onpassive-nov(1)/assets/images/robot.png"
        width="100%"
        alt="robot"
      />
    </div>
    <div class="logo order-sm-1">
      <img
        src="{{ onPassiveBaseUrl }}onpassive-nov(1)/assets/images/logo.png"
        alt="logo"
      />
    </div>
  </div>
  <div class="container-fluid">
    <div class="all-div">
      <div class="row d-flex justify-content-between flex-row-reverse">
        <div class="col-lg-4">
          <div class="wrapper">
            <h1>NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS</h1>
          </div>
          <div class="video_box">
            <video
              id="my-video"
              class="video-js video-size w-100 h-auto"
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
              width="70%"
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
        <div class="col-lg-4 content-right">
          <div>
            <svg viewBox="0 0 500 100">
              <symbol id="s-text">
                <text text-anchor="middle" x="50%" y="80%">Launching Soon</text>
              </symbol>
              <g class="g-ants">
                <use xlink:href="#s-text" class="text-copy"></use>
                <use xlink:href="#s-text" class="text-copy"></use>
                <use xlink:href="#s-text" class="text-copy"></use>
                <use xlink:href="#s-text" class="text-copy"></use>
                <use xlink:href="#s-text" class="text-copy"></use>
              </g>
            </svg>
          </div>
          <p id="text">
            There is always light at the end of the tunnel, but we at ONPASSIVE
            make sure that you don’t get lost in the tunnel searching for the
            light. Find the best business opportunities that will guide you in
            your path to success. A network marketing opportunity with a
            sophisticated automated system is helping millions to build their
            business along with their dreams. Be a part of ONPASSIVE and
            experience how it feels like to be at the end of the tunnel.
          </p>
          <div class="text-left founder-btn">
            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              target="_blank"
              rel="noopener"
              class="animated-button1"
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              Become a Founder
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
